export default "__VITE_ASSET__eAxSE50e__"